import { Link } from "wouter";
import { AlertCircle, Home, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center px-4 max-w-md">
        <div className="w-16 h-16 mx-auto rounded-full bg-destructive/10 border border-destructive/20 flex items-center justify-center mb-4">
          <AlertCircle className="w-8 h-8 text-destructive/60" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">Page Not Found</h1>
        <p className="text-sm text-muted-foreground mb-6">
          This page doesn't exist. You might have followed an old link or typed the URL incorrectly.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link href="/dashboard">
            <Button size="sm" className="gap-2">
              <Home className="w-4 h-4" />
              Dashboard
            </Button>
          </Link>
          <Link href="/help">
            <Button variant="outline" size="sm" className="gap-2">
              <HelpCircle className="w-4 h-4" />
              Help & FAQ
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
